import { Controller } from '@hotwired/stimulus';
import Cookies from 'js-cookie';

export default class extends Controller {
  setCookieWhenPostponed() {
    Cookies.set('social_terms_check', 'off', { expires: 1 });
  }
}
